//TODO: Need to discuss the details with Nick M. and the team

import React from 'react';
import { DisplayContent } from 'sg-ui-components';

const LoadingIndicator = ({ priority = 'medium' }) => {
    return (
        <React.Fragment key='loading-indicator-section'>
            <div className='loading-indicator'>
                <div className='d-flex justify-content-center bg-white'>
                    <div className='loading-indicator-spinner' role='status'>
                        <span className='sr-only'>Loading...</span>
                    </div>
                </div>

                <div className='loading-indicator-fail-message'>
                    <DisplayContent note='Critical issue: the site is not working' isVisible={priority == 'critical'}>
                        <p>Something went wrong! Please refresh the page or come back later.</p>
                    </DisplayContent>

                    <DisplayContent note='Medium issue: a page refresh might fix the problem' isVisible={priority == 'medium'}>
                        <p>Something went wrong! Please refresh the page or come back later.</p>
                    </DisplayContent>
                </div>
            </div>
        </React.Fragment>
    );
};

export default LoadingIndicator;
